import { mediaItems } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20thumbnail%20showing%20a%20romantic%20historical%20Chinese%20drama%20scene%20with%20traditional%20costumes%20in%20soft%20coral%20pink%20and%20warm%20golden%20lighting%20with%20elegant%20palace%20background%20and%20cherry%20blossom%20petals%20floating%20cinematic%20atmosphere%20with%20film%20grain%20texture&width=640&height=360&seq=media-card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20warm%20nostalgic%20school%20campus%20scene%20with%20cherry%20blossoms%20and%20young%20students%20walking%20under%20sunlight%20in%20soft%20peach%20and%20cream%20tones%20cinematic%20photography%20style%20with%20dreamy%20summer%20atmosphere%20and%20gentle%20lens%20flare&width=640&height=360&seq=media-card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20space%20scene%20with%20starship%20floating%20above%20a%20distant%20planet%20in%20warm%20golden%20amber%20and%20coral%20toned%20nebula%20cinematic%20digital%20art%20style%20with%20epic%20composition%20and%20soft%20atmospheric%20glow&width=640&height=360&seq=media-card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20warm%20tropical%20Bangkok%20cityscape%20at%20sunset%20with%20golden%20temples%20and%20modern%20skyline%20in%20soft%20peach%20and%20amber%20tones%20cinematic%20travel%20photography%20style%20with%20atmospheric%20haze%20and%20warm%20color%20grading&width=640&height=360&seq=media-card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20vibrant%20variety%20show%20stage%20with%20colorful%20lighting%20and%20comedic%20atmosphere%20in%20warm%20coral%20pink%20and%20golden%20tones%20entertainment%20photography%20style%20with%20dynamic%20composition%20and%20cheerful%20mood&width=640&height=360&seq=media-card-05&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-play-circle-line"></i>
            <span>精彩视频</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            精选蜜桃视频、桃子视频、苹果视频等品牌超清热门内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <a
              key={item.id}
              href={item.url}
              className="group rounded-xl overflow-hidden bg-background-50 hover:ring-2 hover:ring-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={mediaImages[idx]}
                  alt={`${item.title} - 糖心视频${item.category}超清在线`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-black/50 text-white backdrop-blur-sm whitespace-nowrap">
                    {item.duration}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500/80 text-white backdrop-blur-sm whitespace-nowrap">
                    {item.quality}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
              </div>

              <div className="p-4">
                <p className="text-xs text-primary-600 font-medium mb-1">
                  {item.category}
                </p>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line text-xs"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}